import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Debug } from "../../../Molecules/Forms/Debug";
import { Button, Dialog, BasicInfoForm, FieldsForm, TaskName, Grid, SubmitButton, Tabs, EditorState, ContentState, htmlToDraft, convertToRaw, draftToHtml } from "../../..";
import { makeStyles } from "@material-ui/core/styles";
var taskSchema = Yup.object().shape({
  name: Yup.string().min(2, "Too Short!").required("Campo obligatorio"),
  heading: Yup["boolean"](),
  daysToDeadline: Yup.number(),
  repeat: Yup["boolean"](),
  untilEOS: Yup["boolean"](),
  repeatsDays: Yup.number().when("repeat", {
    is: true,
    then: Yup.number().required("Campo obligatorio")
  }),
  maxRepeats: Yup.number().when(["repeat", "untilEOS"], {
    is: function is(repeat, untilEOS) {
      return repeat && !untilEOS;
    },
    then: Yup.number().required("Campo obligatorio")
  }),
  details: Yup.string().when("heading", {
    is: false,
    then: Yup.string().min(2, "Too Short!").required("Campo obligatorio")
  }),
  extraFields: Yup.array().of(Yup.object().shape({
    name: Yup.string(),
    // these constraints take precedence
    type: Yup.string().min(4, "Selecciona un tipo"),
    // these constraints take precedence
    isMandatory: Yup["boolean"](),
    options: Yup.array().when("type", {
      is: "select",
      then: Yup.array().of(Yup.object().shape({
        value: Yup.string()
      }))
    })
  }))
});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    form: {
      display: "flex"
    },
    repeat: {
      margin: 0
    },
    mr30: {
      "margin-right": "30px"
    },
    actions: {
      display: "flex",
      padding: "30px",
      "justify-content": "flex-end"
    },
    repeatField: {
      width: "50%",
      "margin-right": "20px"
    },
    flex: {
      display: "flex"
    }
  };
});

var DialogChecklist = function DialogChecklist(props) {
  // console.log('DialogChecklist props');
  // console.log(props);
  var _useState = useState("basicData"),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1]; // const [ data, setData ] = useState(props.data || initialValues);


  var initialValues = props.data ? _objectSpread(_objectSpread({}, props.data), {}, {
    details: props.data.details ? EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(props.data.details).contentBlocks, htmlToDraft(props.data.details).entityMap)) : EditorState.createEmpty()
  }) : {
    details: EditorState.createEmpty()
  };

  var handleTabs = function handleTabs(event, newValue) {
    setValue(newValue);
  };

  var classes = useStyles();
  var tabs = [{
    label: "Basic Info",
    value: "basicData"
  }, {
    label: "Fields",
    value: "fields"
  } // DEPENDENCIAS DESACTIVADAS
  // { label: 'Dependencias', value: 'relatedTasks' }
  ];

  var contentTabHandler = function contentTabHandler(values) {
    switch (value) {
      case "basicData":
        return /*#__PURE__*/React.createElement(BasicInfoForm, {
          values: values,
          mode: props.variant
        });

      case "fields":
        return /*#__PURE__*/React.createElement(FieldsForm, {
          values: values,
          mode: props.variant
        });
      // DEPENDENCIAS DESACTIVADAS
      // case 'relatedTasks':
      // 	return <RelatedTasksForm values={values} taskList={props.taskList} mode={props.variant} />;

      default:
        return /*#__PURE__*/React.createElement(BasicInfoForm, {
          values: values,
          mode: props.variant
        });
    }
  };

  return [/*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "lg",
    title: "A\xF1adir tarea",
    open: props.open,
    onClose: props.onClose,
    mode: props.variant,
    key: 0
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validationSchema: taskSchema,
    onSubmit: function onSubmit(values) {
      // setTimeout(() => {
      //   alert(JSON.stringify(values, null, 2));
      // }, 500);
      // console.log(
      //   JSON.stringify({
      //     ...values,
      //     details: draftToHtml(
      //       convertToRaw(values.details.getCurrentContent())
      //     )
      //   })
      // );
      values.heading ? props.createTask({
        name: values.name,
        heading: values.heading,
        _id: values._id,
        key: values.key,
        parent: values.parent,
        children: values.children,
        order: 0,
        details: draftToHtml(convertToRaw(values.details.getCurrentContent()))
      }) : props.createTask(_objectSpread(_objectSpread({}, values), {}, {
        details: draftToHtml(convertToRaw(values.details.getCurrentContent()))
      }));
    },
    render: function render(_ref) {
      var values = _ref.values,
          setFieldValue = _ref.setFieldValue,
          handleBlur = _ref.handleBlur,
          isValid = _ref.isValid,
          isSubmitting = _ref.isSubmitting;
      return /*#__PURE__*/React.createElement(Form, {
        "data-cy": "dialog-checklist",
        className: classes.form
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.root
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12,
        className: classes.editor
      }, /*#__PURE__*/React.createElement(TaskName, {
        mode: props.variant
      })), !values.heading && [/*#__PURE__*/React.createElement(Tabs, {
        value: value,
        onChange: handleTabs,
        variant: "standard",
        indicatorColor: "primary",
        textColor: "primary",
        contentTabs: tabs
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12,
        className: classes.editor
      }, contentTabHandler(values))], props.variant !== "view" && /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.actions
      }, /*#__PURE__*/React.createElement(Button, {
        type: "button",
        size: "medium",
        className: classes.mr30,
        color: "secondary",
        variant: "outlined",
        onClick: props.onClose
      }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
        size: "medium",
        className: classes.mr30,
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, "Save Task"))));
    }
  })))];
};

export { DialogChecklist };